<script lang="ts">
  import type { Snippet } from 'svelte';
  interface Props {
    showModal: boolean;
    children: Snippet;
    onclose?: () => void;
  }
  let { showModal = $bindable(), children, onclose }: Props = $props();
  let dialog = $state<HTMLDialogElement>();

  $effect(() => {
    if (showModal) {
      dialog?.showModal();
    } else {
      dialog?.close();
    }
  });
</script>

<dialog
  class="modal"
  bind:this={dialog}
  onclose={() => {
    showModal = false;
    onclose?.();
  }}
  onclick={(e) => {
    if (e.target === dialog) {
      showModal = false;
    }
  }}
>
  <div class="modal-content">
    {@render children?.()}
  </div>
</dialog>

<style>
  .modal::backdrop {
    background: rgba(0, 0, 0, 0.75);
    backdrop-filter: blur(4px);
  }

  .modal {
    background: transparent;
    border: none;
  }

  .modal-content {
    background-color: var(--color-zinc-800);
    color: var(--color-zinc-200);
    padding: 1.5rem;
    border-radius: 0.75rem;
    max-width: 40rem;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.6);
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
</style>
